import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSelectionListValue } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for updating a Selection List Value.
 */
export const useUpdateSelectionListValue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call updateSelectionListValue.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} params.id Selection List ID
     * @param {Pella.ProductionRequestAPI.UpdateSelectionListInput} params.input
     */
    mutationFn: ({ id, input }) => updateSelectionListValue(id, input),
    onSuccess: () => {
      toast.success('Selection List Value updated successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SELECTION_LISTS] });
    },
  });
};
